import { getRouteApi } from '@tanstack/react-router';
import { TextInput } from 'cpool-components/input/TextInput';
import type { LOAN_REQUEST_COMMAND } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormField';
import { subFieldLabelClassName } from '~/features/leadDetails/components/Overview/CustomerData/shared/subFieldLabel.ts';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import type { SchemaIncomeForm } from '~/features/leadDetails/schemas/income.schema.ts';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

type Props = {
    name: `sonstigeEinnahmen.${number}.notiz`;
    isSecondApplicant?: boolean;
    commandName: LOAN_REQUEST_COMMAND;
};

export const IncomeFieldNote: React.FC<Props> = ({ commandName, isSecondApplicant, name }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { t } = useTranslation();
    const { control } = useFormContext<SchemaIncomeForm>();

    return (
        <FormField<SchemaIncomeForm, string | null> control={control} name={name}>
            {({ error, onBlur, onChange, value }) => (
                <TextInput
                    id={name}
                    label={t('LEADS.DETAILS.INCOME.NOTE')}
                    labelClassName={subFieldLabelClassName}
                    className="w-full"
                    value={value ?? ''}
                    onBlur={onBlur}
                    onChange={(event) => onChange(event.target.value || null)}
                    disabled={
                        !canExecuteApplicantCommand({ applicant: isSecondApplicant ? 2 : 1, commandName, permissions })
                    }
                    error={error}
                />
            )}
        </FormField>
    );
};
